import capsule from "@/constants/capsule";
import { Text, Flex } from "@chakra-ui/react";
import { CapsuleModal } from "@usecapsule/react-sdk";
import { useEffect, useState, useRef } from "react";
import { useUserInfo } from "@/context/UserInfo";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";

// Import Swiper styles
import "swiper/css";
import Slider1 from "./Slider1";
import Slider2 from "./Slider2";
import Pagination from "./Pagination";
import Slider3 from "./Slider3";
import Slider4 from "./Slider4";
import Slider5 from "./Slider5";
const Login = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { handleCheckUserStatus } = useUserInfo();
  const [currentIndex, setCurrentIndex] = useState(-1);
  const swiperRef = useRef<SwiperType>();

  const handleCloseCapsuleModal = () => {
    handleCheckUserStatus();
    setIsOpen(false);
  };

  useEffect(() => {
    setCurrentIndex(0);
  }, []);

  const handleScreenClick = (e: React.MouseEvent) => {
    if (!swiperRef.current) return;

    const { clientX } = e;
    const { innerWidth } = window;
    const halfWidth = innerWidth / 2;

    if (clientX < halfWidth) {
      swiperRef.current.slidePrev();
    } else {
      swiperRef.current.slideNext();
    }
  };

  return (
    <Flex
      onClick={handleScreenClick}
      sx={{
        background: "#FFFCF9",
        width: "100%",
        height: "100%",
        padding: "20px",
      }}
      flexDir={"column"}
    >
      <Pagination currentIndex={currentIndex} total={5}></Pagination>
      <Swiper
        modules={[Autoplay]}
        slidesPerView={1}
        allowTouchMove={false}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        onSlideChange={(swiper) => {
          setCurrentIndex(swiper.activeIndex);
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        style={{
          width: "100%",
          flex: 1,
          paddingBottom: "15px",
        }}
      >
        <SwiperSlide style={{ height: "100%" }} key={0}>
          {currentIndex == 0 && <Slider1></Slider1>}
        </SwiperSlide>
        <SwiperSlide style={{ height: "100%" }} key={1}>
          {currentIndex == 1 && <Slider2></Slider2>}
        </SwiperSlide>
        <SwiperSlide style={{ height: "100%" }} key={2}>
          {currentIndex == 2 && <Slider3></Slider3>}
        </SwiperSlide>
        <SwiperSlide style={{ height: "100%" }} key={3}>
          {currentIndex == 3 && <Slider4></Slider4>}
        </SwiperSlide>
        <SwiperSlide style={{ height: "100%" }} key={4}>
          {currentIndex == 4 && <Slider5></Slider5>}
        </SwiperSlide>
      </Swiper>

      <Flex
        align={"center"}
        justify={"center"}
        sx={{
          background: "#D8762B",
          width: "100%",
          height: "60px",
          borderRadius: "100px",
        }}
        onClick={() => setIsOpen(true)}
      >
        <Text
          sx={{
            fontSize: "16px",
            marginRight: "4px",
            color: "#fff",
          }}
        >
          Login
        </Text>
      </Flex>

      <CapsuleModal
        capsule={capsule}
        isOpen={isOpen}
        onClose={() => {
          handleCloseCapsuleModal();
        }}
      />
    </Flex>
  );
};

export default Login;
